/* eslint-disable react/no-unescaped-entities */
import { Button, Dialog, DialogActions, DialogTitle, Grid, LinearProgress } from '@material-ui/core'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import NotificationFormModal from '../../components/NotificationFormModal'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import {
  deletePushNotification,
  getPushNotificationsList,
  getSearch
} from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function NotificationsPage() {
  const { setUser, setOpenToast, setAboutCurrentPage, setShowLoadingModal } = useContext(Context)

  const [notificationsList, setNotificationsList] = useState([])
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [fullNotificationsList, setFullNotificationsList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [deleteModalData, setDeleteModalData] = useState(null)
  const [editData, setEditData] = useState(null)

  const showDeleteModal = item => setDeleteModalData(item)
  const hideDeleteModal = () => setDeleteModalData(null)

  const getPushList = () => {
    getPushNotificationsList().then(r => {
      if (r) {
        setNotificationsList(r)
        setFullNotificationsList(r)
        setIsLoading(false)
      } else {
        console.log({ error: r })
      }
    })
  }

  const deleteItem = async item => {
    setIsLoading(true)
    setDeleteModalData(null)
    let deleted = await deletePushNotification(item)
    let data = await getPushNotificationsList()
    setNotificationsList(data)
    setFullNotificationsList(data)
    if (deleted.message)
      setOpenToast({
        open: true,
        message: deleted.message,
        type: 'error'
      })
    setIsLoading(false)
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Notificações'
      // buttons: [{ title: 'Adicionar Notificação', pathname: '/challenge' }],
    })
    getPushList()
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('pushNotification', searchData.str).then(r => {
        if (r) {
          setNotificationsList(r)
          setSearchData({ ...searchData, startSearch: false })
          setIsLoading(false)
        } else {
          setNotificationsList([])
        }
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setNotificationsList(fullNotificationsList)
    }
  }, [searchData])

  return (
    <div className="container-fluid h-100">
      <Grid container style={{ padding: 15 }} justify="center">
        <Grid item xs={12}>
          <ToastMessages />
        </Grid>
        {isLoading ? (
          <Grid item xs={12}>
            <LinearProgress marginTop="30px" />
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Context.Provider
                value={{ searchData, setSearchData, setEditPushNotificationData: setEditData }}
              >
                <TopSearch searchAction={() => {}} filterAction={() => {}} showAddPushButton />
              </Context.Provider>
              <div className="row">
                {notificationsList
                  .sort((a, b) => (a.dateTimeSend > b.dateTimeSend ? -1 : 1))
                  .map(item => (
                    <div key={item.id} className="col-sm-12" style={{ padding: '10px' }}>
                      <div className="card" style={{ minHeight: '200px' }}>
                        <div className="card-body">
                          <h4
                            className="card-title w-100 d-flex justify-content-between align-content-center"
                            style={{ minHeight: 60 }}
                          >
                            {item.title}{' '}
                            {item.situation === 9 && (
                              <small style={{ fontSize: 16, color: 'red' }}>Agendado</small>
                            )}
                            {item.situation === 10 && (
                              <small style={{ fontSize: 16, color: 'green' }}>Enviado</small>
                            )}
                          </h4>
                          <div className="row">
                            {item.image && (
                              <div className="col-2">
                                <img src={item.image} alt="" style={{ maxWidth: '100%' }} />
                              </div>
                            )}
                            <div className={item.image ? 'col-10' : 'col-12'}>
                              <p className="card-text">{item.body}</p>
                              <p>
                                <strong>Hora agendada:</strong>{' '}
                                {moment(item.dateTimeSend).format('DD/MM/YYYY HH:mm')}
                              </p>
                              {item.situation === 9 && (
                                <>
                                  <Button variant="outlined" onClick={() => showDeleteModal(item)}>
                                    Excluir
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setEditData(item)}
                                    data-toggle="modal"
                                    data-target="#addNotification"
                                  >
                                    Editar
                                  </Button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Context.Provider
                value={{
                  setNotificationsList,
                  setOpenToast,
                  getPushList,
                  setShowLoadingModal
                }}
              >
                <NotificationFormModal editData={editData} />
              </Context.Provider>
            </Grid>
            <Dialog open={!!deleteModalData} transitionDuration={{ enter: 250, exit: 0 }}>
              <DialogTitle>Quer mesmo excluir "{deleteModalData?.title}"?</DialogTitle>
              <DialogActions>
                <Button type="primary" onClick={() => deleteItem(deleteModalData)}>
                  Sim
                </Button>
                <Button type="primary" onClick={hideDeleteModal}>
                  Não
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Grid>
    </div>
  )
}

export default NotificationsPage
